import { CartLinesUpdateEvent } from '@shopify/events';

/**
 * Bouton d'ajout 1-clic pour l'upsell panier.
 * Ajoute la variante par défaut du produit et rafraîchit le tiroir via le
 * mécanisme natif Horizon (CartLinesUpdateEvent + section rendering).
 */
class CartUpsellAdd extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.button?.addEventListener('click', this.#add);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.#add);
  }

  #add = async (event) => {
    event.preventDefault();

    const variantId = this.dataset.variantId;
    const sectionId = this.dataset.sectionId || 'cart-drawer-section';
    if (!variantId || this.button?.hasAttribute('disabled')) return;

    this.button.setAttribute('disabled', '');
    this.button.classList.add('loading');

    const deferred = CartLinesUpdateEvent.createPromise();

    this.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'cart-upsell',
        lines: [{ merchandiseId: variantId, quantity: 1 }],
        promise: deferred.promise,
      })
    );

    try {
      const response = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }],
          sections: sectionId,
        }),
      }).then((r) => r.json());

      if (response.status) {
        deferred.reject(new Error(response.message || 'Add to cart failed'));
        this.button.removeAttribute('disabled');
        this.button.classList.remove('loading');
        return;
      }

      const cart = await fetch(`${Theme.routes.cart_url || '/cart'}.js`).then((r) => r.json());

      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: {
          items: cart.items,
          source: 'cart-upsell',
          sections: response.sections,
          didError: false,
        },
      });
    } catch (error) {
      deferred.reject(error);
      this.button.removeAttribute('disabled');
      this.button.classList.remove('loading');
    }
  };
}

if (!customElements.get('cart-upsell-add')) {
  customElements.define('cart-upsell-add', CartUpsellAdd);
}
